import { GroupRoles } from 'api/organizations/inviteNewOrganizationMember';

import { ALLOWED_TO_CREATE_ORGANIZATION } from './constants';

export const isAllowedToCreateOrganization = (
    groupRoles: GroupRoles | null
) => {
    return ALLOWED_TO_CREATE_ORGANIZATION.some((role) =>
        groupRoles?.includes(role)
    );
};
